module.exports = '<svg width="24" height="32" viewBox="0 0 24 32"><path d="M20 8c0-4.412-3.588-8-8-8S4 3.588 4 8v2H1.02C.466 10 0 10.448 0 11v19c0 1.106.914 2 2.02 2h20c1.106 0 1.98-.894 1.98-2V11c0-.552-.428-1-.98-1H20V8zM8 10V8c0-2.206 1.794-4 4-4s4 1.794 4 4v2H8z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/bag-1.js
// module id = 995
// module chunks = 14